var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDollarLWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 40,
    viewBox: "0 0 23 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5667 17.6167C7.64836 16.3383 6.06669 15.0167 6.06669 12.9583C6.06669 10.5967 8.25503 8.95 11.9167 8.95C15.7734 8.95 17.2034 10.7917 17.3334 13.5H22.1217C21.97 9.77333 19.695 6.35 15.1667 5.245V0.5H8.66669V5.18C4.46336 6.09 1.08336 8.82 1.08336 13.0017C1.08336 18.0067 5.22169 20.4983 11.2667 21.95C16.6834 23.25 17.7667 25.1567 17.7667 27.1717C17.7667 28.6667 16.705 31.05 11.9167 31.05C7.45336 31.05 5.69836 29.0567 5.46003 26.5H0.693359C0.953359 31.245 4.50669 33.91 8.66669 34.7983V39.5H15.1667V34.8417C19.3917 34.04 22.75 31.5917 22.75 27.15C22.75 20.9967 17.485 18.895 12.5667 17.6167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollarLWhite);
export default __webpack_public_path__ + "static/media/icon-dollar-l-white.b9ddf79d3ece49894b778245082e905c.svg";
export { ForwardRef as ReactComponent };